import HTTP from "../../../services/HTTP.js";
// fetch Deliverables
export const getDeliverables = async (paramsOptions) => {
  const { page, limit } = paramsOptions || {};
  const res = await HTTP.get("deliverables", {
    params: {
      page,
      limit,
    },
  });
  return res.data;
};

// fetch Deliverable history by id
export const getDeliverableHistoryById = async (paramsOptions) => {
  const { page, limit, deliverableId } = paramsOptions || {};
  const res = await HTTP.get(`deliverables/history/${deliverableId}`, {
    params: {
      page,
      limit,
    },
  });
  return res.data;
};

// add Deliverable
export const addDeliverable = async (data) => {
  const res = await HTTP.post("deliverables/add", data);
  return res.data;
};

// update Deliverable
export const updateDeliverable = async (data) => {
  const res = await HTTP.put("deliverables/update", data);
  return res.data;
};
// delete Deliverable
export const deleteDeliverable = async (id) => {
  const res = await HTTP.delete(`deliverables/delete/${id}`);
  return res.data;
};
